var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategoryHobbies(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 52,
    viewBox: "0 0 51 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1305_8084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.2724 21.3695C41.2307 24.1184 41.6594 27.7099 40.307 30.8062C38.8364 34.1537 36.4864 37.3757 33.3383 40.0877C24.2488 47.9282 11.9372 48.5416 5.84055 41.4696C-0.256107 34.3902 2.16039 22.3079 11.2573 14.4674C17.4057 9.16157 25.0395 7.17373 31.2174 8.62951C34.2251 9.33893 34.6463 13.4624 31.8973 14.8665L29.2222 16.2336C28.1506 16.7804 28.461 18.384 29.6582 18.4948L35.1193 18.99C36.782 19.1377 38.297 20.0097 39.2724 21.3695Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6104 20.2758C20.0062 20.2758 21.1377 19.1443 21.1377 17.7485C21.1377 16.3527 20.0062 15.2212 18.6104 15.2212C17.2145 15.2212 16.083 16.3527 16.083 17.7485C16.083 19.1443 17.2145 20.2758 18.6104 20.2758Z",
    fill: "#FF8B8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2871 25.6925C12.6829 25.6925 13.8145 24.561 13.8145 23.1652C13.8145 21.7694 12.6829 20.6379 11.2871 20.6379C9.8913 20.6379 8.75977 21.7694 8.75977 23.1652C8.75977 24.561 9.8913 25.6925 11.2871 25.6925Z",
    fill: "#FF9C07"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.16601 34.9297C10.5618 34.9297 11.6934 33.7981 11.6934 32.4024C11.6934 31.0066 10.5618 29.8751 9.16601 29.8751C7.7702 29.8751 6.63867 31.0066 6.63867 32.4024C6.63867 33.7981 7.7702 34.9297 9.16601 34.9297Z",
    fill: "#82DBB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3955 42.3416C16.7913 42.3416 17.9228 41.2101 17.9228 39.8143C17.9228 38.4185 16.7913 37.287 15.3955 37.287C13.9997 37.287 12.8682 38.4185 12.8682 39.8143C12.8682 41.2101 13.9997 42.3416 15.3955 42.3416Z",
    fill: "#84BDF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.3721 40.1837C26.7679 40.1837 27.8994 39.0522 27.8994 37.6564C27.8994 36.2607 26.7679 35.1292 25.3721 35.1292C23.9763 35.1292 22.8447 36.2607 22.8447 37.6564C22.8447 39.0522 23.9763 40.1837 25.3721 40.1837Z",
    fill: "#BA94D6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2274 30.0154C35.1905 30.0154 36.7819 28.424 36.7819 26.461C36.7819 24.4979 35.1905 22.9065 33.2274 22.9065C31.2643 22.9065 29.6729 24.4979 29.6729 26.461C29.6729 28.424 31.2643 30.0154 33.2274 30.0154Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.827 44.9962L47.7371 45.6669C47.6891 46.0242 47.2337 46.1244 47.0539 45.8173L46.7183 45.2532C45.5736 43.3416 44.8005 41.2168 44.4409 38.9917L40 11.1818L40.8151 11L47.4914 38.3336C48.0248 40.5085 48.1386 42.7775 47.833 44.9962H47.827Z",
    fill: "#FF8B8B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.3413 12.6052C41.0678 13.2038 40.3067 13.359 39.8189 12.9378C38.2153 11.5337 37.3951 9.44241 37.6167 7.32894L38.1562 2.17828C38.1784 1.98614 38.4296 1.93441 38.5257 2.09699L41.0974 6.60474C42.1468 8.44479 42.2428 10.6765 41.3486 12.5978L41.3413 12.6052Z",
    fill: "#FFC107"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1305_8084",
    x: 0.476562,
    y: 0,
    width: 49.5234,
    height: 48.3959,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0 0.133333 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1305_8084"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1305_8084",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategoryHobbies);
export default __webpack_public_path__ + "static/media/category_hobbies.1ada6ef2fffd4785dc4d9a2cda5a7e86.svg";
export { ForwardRef as ReactComponent };